
import { Component, Vue, Watch, Prop } from "vue-property-decorator"

import api from "@/services/api"

@Component({
	components: {
	}
})
export default class Numeric extends Vue {
	@Prop({ default: "" })
	public value!: string | number;

	@Prop({ type: Boolean, default: false })
	public readonly!: boolean;

	@Prop({ type: Number, default: 2 })
	public precision!: number;

	@Prop({ type: Number, default: null })
	public displayDecimals!: number | null;

	@Prop({ default: "" })
	public prepend!: string;

	public numberValue: string | null = null;

	public mounted () {
		this.setValue(this.value)

		if (this.numberValue != null && this.displayDecimals) {
			const numberSplit = this.numberValue.toString().split(".")
			if (numberSplit.length < 2) {
				this.numberValue += ".00"
			} else {
				this.numberValue = numberSplit[0] + "." + numberSplit[1].padEnd(2, "0")
			}
		}
	}

	get numberDisplayValue (): string {
		if (this.numberValue == null) {
			return ""
		}

		return this.numberValue
	}

	@Watch("value")
	onValueChanged (newValue: any) {
		if (newValue === "-" || newValue === "" || newValue === null || isNaN(parseFloat(newValue))) {
			(this.$refs.input as HTMLInputElement).value = ""
		} else {
			this.setValue(newValue)
		}
	}

	setValue (newValue: any) {
		if (newValue === "-" || newValue === "" || newValue === null || newValue === undefined) {
			this.$emit("input", null)
		}

		if (newValue) {
			if (typeof (newValue) !== "number") {
				newValue = parseFloat(newValue)
			}

			if (isNaN(newValue)) {
				newValue = this.numberValue
			} else {
				newValue = parseFloat(newValue.toFixed(this.precision))
			}
		}

		const oldValue = this.numberValue
		if (oldValue !== newValue) {
			newValue = newValue === "" ? null : newValue
			this.numberValue = newValue
			this.$emit("input", newValue)
		}
	}

	blurValue (newValue: string | number) {
		if (typeof (newValue) !== "number") {
			newValue = parseFloat(newValue)
		}

		if (isNaN(newValue)) {
			this.$emit("blur", null)
		} else {
			if (this.displayDecimals) {
				this.numberValue = newValue.toFixed(2)
			}

			this.$emit("blur", newValue)
		}
	}
}
